export default __webpack_public_path__ + "static/ip-asset-assessment-tool-39ff1a099a935963cca2f35fea193627.png";